import Box from "@mui/material/Box"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import {
  AddLocationAltOutlined,
  ArchiveOutlined,
  CheckCircleOutlined,
  VerticalAlignBottomOutlined,
} from "@mui-symbols-material/w300"
import { Link, Outlet, useLocation } from "@tanstack/react-router"
import type { FC } from "react"
import { useEffect } from "react"

const TabLabel = ({ icon, label }: { icon: React.ReactNode; label: string }) => {
  return (
    <Box className='flex items-center gap-2'>
      {icon} {label}
    </Box>
  )
}

export const TabletWarehouseReceivingLayout: FC = () => {
  const location = useLocation()

  useEffect(() => {
    const handleOrientationChange = () => {
      window.dispatchEvent(new Event("resize"))
    }

    window.addEventListener("orientationchange", handleOrientationChange)
    if (window.screen?.orientation) {
      window.screen.orientation.addEventListener("change", handleOrientationChange)
    }

    return () => {
      window.removeEventListener("orientationchange", handleOrientationChange)
      if (window.screen?.orientation) {
        window.screen.orientation.removeEventListener("change", handleOrientationChange)
      }
    }
  }, [])

  const tabs = [
    {
      label: <TabLabel icon={<VerticalAlignBottomOutlined />} label='Incoming' />,
      path: "/app/tablet/warehouse-receiving/incoming",
    },
    {
      label: <TabLabel icon={<ArchiveOutlined />} label='Soft Received' />,
      path: "/app/tablet/warehouse-receiving/soft-received",
    },
    {
      label: <TabLabel icon={<CheckCircleOutlined />} label='Checked In' />,
      path: "/app/tablet/warehouse-receiving/checked-in",
    },
    {
      label: <TabLabel icon={<AddLocationAltOutlined />} label='Stored' />,
      path: "/app/tablet/warehouse-receiving/stored",
    },
  ]

  const activeTab = tabs.find((tab) => location.pathname.startsWith(tab.path)) ?? tabs[0]
  return (
    <Box className='flex w-full flex-1 flex-col overflow-hidden p-6'>
      <Tabs value={activeTab.path} variant='fullWidth' scrollButtons='auto'>
        {tabs.map((tab) => (
          <Tab key={tab.path} label={tab.label} value={tab.path} component={Link} to={tab.path} />
        ))}
      </Tabs>

      <Box className='flex min-h-0 grow flex-col px-1 pb-1 pt-6'>
        <Outlet />
      </Box>
    </Box>
  )
}
